import { useEffect, useState } from 'react';
import { PatientDosageDiaryItem } from '../interface/interface';
import { fetchPatientDosageDiaries } from '../service/fetchPatientDosageDiaries';

export function useToFetchPatientDosageDiaries(
  token: string,
): [Array<PatientDosageDiaryItem>] {
  const [dosageDiaries, setDosageDiaries] = useState<
    Array<PatientDosageDiaryItem>
  >([]);

  useEffect(() => {
    fetchPatientDosageDiaries(token).then((res) => {
      if (typeof res === 'number') {
        console.log('Unable to fetch dosage diaries:', res);
        return;
      }

      setDosageDiaries(res);
    });
  }, [token]);

  return [dosageDiaries];
}
